import Vue from 'vue'

export default class Auth {

    constructor() {
        //console.log(Vue);
        this.baseUrl = Vue.configApp.backendUrl + "api/auth/";
        //console.log(this.baseUrl);
        this.username = "";
        this.isLogged = "";
        this.sessionId = "";
        this.firstName = "";
        this.lastName = "";
    }

    autologin(token){
        localStorage.setItem("app-token",token);
    }
    
    login(username, password, cb) {
        //let self = this;
        //console.log("login : ", username,password);
        //console.log(Vue.axios);
        //console.log(this.baseUrl + "login");
        Vue.axios.post(this.baseUrl + "login", JSON.stringify({
            username: username,
            password: password,
        }))
        .then((response) => {
            //console.log(this.baseUrl + "login");
            let token = (response.data) ? response.data.token : '';
            localStorage.setItem("app-token",token);
            //console.log(response.data)
            if(token.length > 0) {                
                cb({
                    username: username,
                    isLogged: true,
                    sessionId: "",
                    firstName: "",
                    lastName: ""
                });
            }
            else {
                cb({
                    username: "",
                    isLogged: false,
                    sessionId: "",
                    firstName: "",
                    lastName: ""
                });
            }
        })
        .catch(function (error) {
            console.log('ERROR')
            console.log(error);
            cb({
                username: "",
                isLogged: false,
                sessionId: "",
                firstName: "",
                lastName: ""
            });
        })
    }
    logout(cb) {
        localStorage.setItem("app-token","");
        cb({result: true});
    }
    getToken() {
        let token = localStorage.getItem("app-token");
        if(token == null) token = "";
        return token;
    }
    getHeader() {
        //Vue.axios.defaults.headers.common['Authorization'] =  'Bearer ' + this.getToken();
        //console.log(Vue.axios.defaults.headers.common['Authorization']);
        return {
            headers: { Authorization: "Bearer " + this.getToken() }
        };
    }
    checkLogin(cb) {
        let token = this.getToken();
        if(token.length == 0) return false;

        Vue.axios.get(this.baseUrl + "check-login",this.getHeader())
        .then((response) => {
            cb(response.data);            
        })
        .catch(function (error) {
            console.log(error);           
            cb({ success: false});            
        });
    }
}
